import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f9abf8e2&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=f9abf8e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9abf8e2",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteAboutProvider: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/site/about-provider.vue').default,SiteAwardsWinner: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/site/awards-winner.vue').default,ProductsPrepayCardsResults: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/products/prepay-cards/results.vue').default,ProductsProviderArticles: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/products/provider-articles.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/site/feefo.vue').default})
